import { Cliente } from '@/models'
import { aplicarMascaraParaCpfOculto, formatarCnpjOuCpf, removerFormatacaoDeCnpjOuCpf } from '@/shareds/formatadores'
import { PreVenda } from '@/models/pre-venda/PreVenda'

export type DestinatarioDaVenda = {
	cliente: Cliente | null
	cpfDoCliente: string | null
}

/**
 * Define o destinatário da venda/nota ao importar uma pré-venda.
 *
 * Quando a pré-venda informa um cliente, ele é o destinatário, mesmo que a tela
 * já tenha outro CPF/CNPJ digitado. Quando a pré-venda não informa cliente, o
 * destinatário já informado na tela é preservado (importar a pré-venda não pode
 * apagar o que o operador digitou).
 */
export function resolverDestinatarioDaPreVenda(
	clienteDaPreVenda: Cliente | null,
	cpfOuCnpjDaPreVenda: string | null,
	destinatarioDaTela: DestinatarioDaVenda | null,
): DestinatarioDaVenda {
	if (clienteDaPreVenda) {
		return {
			cliente: clienteDaPreVenda,
			cpfDoCliente: cpfOuCnpjDaPreVenda || clienteDaPreVenda.cnpjOuCpf || '',
		}
	}

	return {
		cliente: destinatarioDaTela?.cliente ?? null,
		cpfDoCliente: destinatarioDaTela?.cpfDoCliente ?? '',
	}
}

export function formatarCnpjOuCpfParaExibicao(cnpjOuCpf: string | null | undefined): string {
	if (!cnpjOuCpf) return ''
	const cnpjOuCpfSemMascara = removerFormatacaoDeCnpjOuCpf(cnpjOuCpf)
	return cnpjOuCpfSemMascara.length <= 11
		? aplicarMascaraParaCpfOculto(cnpjOuCpfSemMascara)
		: formatarCnpjOuCpf(cnpjOuCpf)
}

export function obterDisplayClienteDaPreVenda(preVenda: { cpfOuCnpjDoCliente: string | null; cliente?: Cliente | null }): string {
	const cnpjOuCpf = formatarCnpjOuCpfParaExibicao(preVenda.cpfOuCnpjDoCliente || preVenda.cliente?.cnpjOuCpf)
	const nome = preVenda.cliente?.razaoSocialOuNome
	if (!cnpjOuCpf) return nome || ''
	return nome ? `${cnpjOuCpf} - ${nome}` : cnpjOuCpf
}

export function descreverFormaDePagamentoSugerida(
	preVenda: Pick<PreVenda, 'tipoDePagamentoSugeridoNome' | 'qtdeDeParcelasSugerida'> | null | undefined,
): string | null {
	if (!preVenda?.tipoDePagamentoSugeridoNome) return null
	return preVenda.qtdeDeParcelasSugerida
		? `${preVenda.tipoDePagamentoSugeridoNome} em ${preVenda.qtdeDeParcelasSugerida}x`
		: preVenda.tipoDePagamentoSugeridoNome
}
